import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import SEO from "@/components/site/SEO";

export default function Barrierefreiheit() {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Barrierefreiheit – FINABLE"
        description="Informationen zur Barrierefreiheit der FINABLE Website – unser Engagement für einen zugänglichen digitalen Auftritt für alle Menschen."
        canonical="https://finable.de/barrierefreiheit"
      />
      <Header alwaysSolid />
      <main className="pt-32 pb-20">
        <article className="container max-w-3xl prose prose-slate dark:prose-invert">
          <h1 className="font-display text-4xl md:text-5xl font-bold text-primary">Barrierefreiheit</h1>

          <p className="mt-6">
            FINABLE ist es wichtig, dass unsere Website für alle Menschen zugänglich ist – unabhängig von körperlichen oder technischen Voraussetzungen. Auf dieser Seite informieren wir Dich über den Stand der Barrierefreiheit unseres Internetauftritts.
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Stand der Barrierefreiheit</h2>
          <p>
            Diese Website ist mit den Anforderungen der Web Content Accessibility Guidelines (WCAG 2.1) auf Niveau AA teilweise vereinbar. Wir arbeiten kontinuierlich daran, die Zugänglichkeit unseres Angebots zu verbessern.
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Was wir bereits umgesetzt haben</h2>
          <ul>
            <li>Kontrastreiche Farbgestaltung für gute Lesbarkeit</li>
            <li>Responsive Design für alle Gerätegrößen (Mobile, Tablet, Desktop)</li>
            <li>Klare Seitenstruktur mit aussagekräftigen Überschriften</li>
            <li>Verständliche Sprache ohne unnötigen Fachjargon</li>
            <li>Verzicht auf blinkende oder störende Animationen</li>
            <li>Verlinkungen mit beschreibenden Linktexten</li>
          </ul>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Bekannte Einschränkungen</h2>
          <ul>
            <li>Eingebettete Videos (Kundenstimmen) enthalten derzeit keine Untertitel</li>
            <li>Einige Bilder verfügen noch nicht über vollständige Alternativtexte</li>
            <li>Die vollständige Tastaturnavigation wird noch optimiert</li>
          </ul>
          <p>Wir arbeiten daran, diese Einschränkungen schrittweise zu beheben.</p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Feedback und Kontakt</h2>
          <p>
            Wenn Du Barrieren auf unserer Website feststellst oder Hilfe benötigst, freuen wir uns über Deine Rückmeldung. Wir bemühen uns, auf Anfragen innerhalb von 5 Werktagen zu antworten.
          </p>
          <p>
            FINABLE GmbH<br />
            Gärtnerstraße 26a<br />
            20253 Hamburg<br />
            E-Mail: <a href="mailto:moin@finable.de" className="text-accent hover:underline">moin@finable.de</a><br />
            Telefon: <a href="tel:+494057249358" className="text-accent hover:underline">040 5724 9358</a>
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Schlichtungsverfahren</h2>
          <p>
            Wenn Du auf Deine Rückmeldung keine zufriedenstellende Antwort erhalten hast, kannst Du Dich an die Schlichtungsstelle nach dem Behindertengleichstellungsgesetz (BGG) wenden.
          </p>

          <h2 className="font-display text-2xl font-bold text-primary mt-10">Datum dieser Erklärung</h2>
          <p>
            Diese Erklärung zur Barrierefreiheit wurde am 25. April 2025 erstellt und zuletzt am 25. April 2026 aktualisiert.
          </p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
